var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H0V22H22V0Z",
    fill: "#F16750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68874 17.3801C6.66039 17.3801 6.63181 17.3747 6.60453 17.3634C6.52235 17.3294 6.46875 17.2491 6.46875 17.1601V4.84012C6.46875 4.71852 6.56725 4.62012 6.68874 4.62012H15.3126C15.4341 4.62012 15.5326 4.71852 15.5326 4.84012V17.1601C15.5326 17.2491 15.479 17.3294 15.3968 17.3634C15.3143 17.3975 15.2199 17.3786 15.157 17.3157L14.3507 16.5093L13.7641 17.292C13.681 17.4029 13.4951 17.4029 13.4121 17.292L12.8249 16.5093L12.0184 17.3157C11.9735 17.361 11.9126 17.385 11.8471 17.3795C11.7836 17.375 11.725 17.3432 11.6868 17.292L11.1001 16.5093L10.2938 17.3157C10.2488 17.361 10.187 17.385 10.1227 17.3795C10.0591 17.375 10.0006 17.3432 9.96232 17.292L9.37526 16.5093L8.56906 17.3157C8.52416 17.361 8.46293 17.385 8.39794 17.3795C8.33434 17.375 8.2758 17.3432 8.23755 17.2922L7.65027 16.5093L6.8443 17.3157C6.80229 17.3578 6.746 17.3801 6.68874 17.3801ZM7.67403 15.9544C7.67918 15.9544 7.68433 15.9546 7.68959 15.9551C7.75318 15.9596 7.81173 15.9914 7.84997 16.0423L8.43726 16.8252L9.24345 16.0189C9.28857 15.9738 9.35131 15.9508 9.41457 15.9551C9.47817 15.9596 9.53671 15.9914 9.57495 16.0425L10.1621 16.8252L10.9684 16.0189C11.0134 15.9738 11.0768 15.9508 11.1396 15.9551C11.2033 15.9596 11.2618 15.9914 11.3 16.0425L11.8867 16.8252L12.6932 16.0189C12.7383 15.9738 12.8009 15.9508 12.8643 15.9551C12.9279 15.9596 12.9865 15.9914 13.0247 16.0425L13.588 16.7934L14.1508 16.0425C14.1891 15.9914 14.2476 15.9596 14.3113 15.9551C14.3738 15.9499 14.4374 15.9738 14.4824 16.0189L15.0926 16.629V5.06012H6.90875V16.6288L7.51847 16.0189C7.55983 15.9774 7.61591 15.9544 7.67403 15.9544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9587 13.0684H12.7266V12.6284H13.9587V13.0684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9587 14.3001H12.7266V13.8601H13.9587V14.3001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0185 7.26007H7.98438V6.82007H14.0185V7.26007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9587 9.37212H12.7266V8.93213H13.9587V9.37212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9587 10.6041H12.7266V10.1641H13.9587V10.6041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9587 11.8362H12.7266V11.3962H13.9587V11.8362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4947 9.37212H8.04492V8.93213H11.4947V9.37212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4947 10.6041H8.04492V10.1641H11.4947V10.6041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4947 11.8362H8.04492V11.3962H11.4947V11.8362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4947 13.0684H8.04492V12.6284H11.4947V13.0684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4947 14.3001H8.04492V13.8601H11.4947V14.3001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.67a65e280f78109ab80d5cc1e8385a9e.svg";
export { ForwardRef as ReactComponent };